import { render, staticRenderFns } from "./chain.vue?vue&type=template&id=a8f7c18e&scoped=true&"
import script from "./chain.vue?vue&type=script&lang=js&"
export * from "./chain.vue?vue&type=script&lang=js&"
import style0 from "./chain.vue?vue&type=style&index=0&id=a8f7c18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f7c18e",
  null
  
)

export default component.exports